import styled from 'styled-components';

export const SectionHeading = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.5715;
  color: ${({ theme }) => theme.palette.grey1100};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    margin-left: 10px;
  }
`;
